import { render, staticRenderFns } from "./sosPosition.vue?vue&type=template&id=5f86837c&scoped=true&"
import script from "./sosPosition.vue?vue&type=script&lang=js&"
export * from "./sosPosition.vue?vue&type=script&lang=js&"
import style0 from "./sosPosition.vue?vue&type=style&index=0&id=5f86837c&prod&lang=css&"
import style1 from "./sosPosition.vue?vue&type=style&index=1&id=5f86837c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f86837c",
  null
  
)

export default component.exports